export const stripSlash = (url: string) => url.replace(/^\/|\/$/g, '')

export const isExternalLink = (url: string) => {
  if (typeof window !== 'undefined') {
    const tmp = document.createElement('a')
    tmp.href = url
    const external = tmp.host !== window.location.host
    const whitelist: string[] = []
    const isWhitelisted = whitelist.some((domain) => tmp.host.endsWith(domain))
    const isPdfOrJpg =
      tmp.pathname.toLowerCase().endsWith('.pdf') ||
      tmp.pathname.toLowerCase().endsWith('.jpg')
    return (external && !isWhitelisted) || isPdfOrJpg
  }
}

export const isBookingLink = (url: string) => {
  return ['book', 'prenota'].includes(stripSlash(url))
}

export const sanitizeAdsLink = (url: string) => {
  if (url.includes('/ads/')) {
    return url.replace(/\/ads\//g, '/')
  } else if (url.includes('/home')) {
    return url.replace(/\/home/g, '/')
  }
  return url
}

export const sanitizeOfficialWebsiteLink = (link: {
  url: string
  title: string
  target?: string | undefined
}) => {
  if (link.target === '_blank' && link.url.startsWith('/')) {
    return link.url.replace(/^\//, 'https://www.rebisrestaurant.com/')
  }
  return link.url
}
